import { Component, Input, OnInit } from '@angular/core';
import { FormGroupDirective, UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { IHundRisiko } from '../../models/hundrisiko';
import { DateService } from '../../service/date.service';

@Component({
  selector: 'app-haftpflicht-hunde',
  templateUrl: './haftpflicht-hunde.component.html',
  styleUrls: ['./haftpflicht-hunde.component.scss']
})
export class HaftpflichtHundeComponent implements OnInit {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  hundeGeschlecht: Map<number, string> =
    new Map([
      [1, 'männlich'],
      [2, 'weiblich']
    ]);

  constructor(private dateService: DateService) { }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      name: new UntypedFormControl('', Validators.required),
      rasse: new UntypedFormControl('', Validators.required),
      geburtsjahr: new UntypedFormControl('', [Validators.pattern('^[0-9]*$'), Validators.required]),
      geschlecht: new UntypedFormControl(''),
    });
  }

  ngOnInit(): void {
    this.geburtsjahr.addValidators([Validators.min(this.dateService.today().getFullYear() - 20),
      Validators.max(this.dateService.today().getFullYear())]);
  }

  get name() { return this.formGroup.get('name'); }
  get rasse() { return this.formGroup.get('rasse'); }
  get geburtsjahr() { return this.formGroup.get('geburtsjahr'); }
  get geschlecht() { return this.formGroup.get('geschlecht'); }

  setHaftpflichtHund(hundRisiko: IHundRisiko) {
    this.name.setValue(hundRisiko.Name);
    this.rasse.setValue(hundRisiko.Rasse);
    this.geburtsjahr.setValue(hundRisiko.Geburtsjahr);
    this.geschlecht.setValue(hundRisiko.Geschlecht);
  }

  getHaftpflichtHund(): IHundRisiko {
    return {
      Name: this.name.value,
      Rasse: this.rasse.value,
      Geburtsjahr: this.geburtsjahr.value,
      Geschlecht: this.geschlecht.value
    };
  }

}
